/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const DatabaseTargetAuthDatabaseTargetPasswordAuthKindEnum = {
    Password: 'Password'
};
/**
 * Check if a given object implements the DatabaseTargetAuthDatabaseTargetPasswordAuth interface.
 */
export function instanceOfDatabaseTargetAuthDatabaseTargetPasswordAuth(value) {
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
export function DatabaseTargetAuthDatabaseTargetPasswordAuthFromJSON(json) {
    return DatabaseTargetAuthDatabaseTargetPasswordAuthFromJSONTyped(json, false);
}
export function DatabaseTargetAuthDatabaseTargetPasswordAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'password': json['password'],
        'kind': json['kind'],
    };
}
export function DatabaseTargetAuthDatabaseTargetPasswordAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'password': value['password'],
        'kind': value['kind'],
    };
}
